import $ from 'jquery';

import App from '@components/App';
import Cache from "@utils/Cache";

class Auth extends App {
    constructor() {
        super();
    }

    bindEvents() {
        $(() => {
            var form = $('#login_form');
            var username = $('#username');
            var password = $('#password');

            form.submit(function () {
                var error = false;
                var authType = window.authType;
                if(isValidUsername(username.val(), authType) === false) {
                    username.parent('div').first().addClass('wrong');
                    $('.form-err').remove();
                    $('.not-username').show(200);
                    error = true;
                }
                if(password.val().length === 0) {
                    password.parent('div').first().addClass('wrong');
                    $('.form-err').remove();
                    $('.not-password').show(200);
                    error = true;
                }
                if(error) {
                    return false;
                } else {
                    return true;
                }
            });

            username.on('focus keypress',function(){
                $('.not-username, .form-err').hide(200);
            });
            password.on('focus keypress',function(){
                $('.not-password').hide(200);
            });
            $(document).on('click', '#form_button', function () {
                Cache.invalidate('/');
                form.submit();
            });
        });
    }

    init() {
        ENV === 'development' && console.log('Auth::init()');

        this.bindEvents();

        super.init();

    }
}

export default Auth;
